// extracted by mini-css-extract-plugin
export default {"scaffold":"l_footer_m_scaffold__gNvJt","f20w700white":"l_footer_m_f20w700white__Ni-Qv","f18w700white":"l_footer_m_f18w700white__rD0cZ","f16w400grey":"l_footer_m_f16w400grey__ohJLP"};